import React from 'react'
import TransactionsListWidget from './TransactionsListWidget'
import TransactionValuesWidget from './TransactionValuesWidget'
import TransactionsCountWidget from './TransactionsCountWidget'
import DashboardTasksWidget from './DashboardTasksWidget'
import CommissionWidget from './CommissionWidget'
import { connect } from 'react-redux'
import { transactionsAction } from './../../actions/DashboardActions'

class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentWillMount(){
    this.props.transactionsAction().then(res => {     
    });
  }

  render() {

    return (
      <div>
        <div className="dash-row">
          <div className="dash-col">
          <div className="dash-col-inner p-0">
            <TransactionsListWidget dashboardTranscations= {this.props.dashboardTranscations} history={this.props.history}/>
            </div>
          </div>
          <div className="dash-col dash-col-big">
            <div className="dash-col-inner">
            <TransactionValuesWidget history={this.props.history}/>
            </div>
          </div>
        </div>

        <div className="dash-row">
          <div className="dash-col" style={{ width: '50%' }}>
            <div className="dash-col-inner dash-col-inner-pie">
              <TransactionsCountWidget countTransactions={this.props.countTransactions}  history={this.props.history}/>
            </div>
          </div>
          <div className="dash-col" style={{ width: '50%' }}>
            <div className="dash-col-inner">
              <CommissionWidget history={this.props.history} />
            </div>
          </div>
        </div>

        <div className="dash-row dash-row-2">
          <DashboardTasksWidget history={this.props.history} />
           </div>

             </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    dashboardTranscations: state.reducer.dashboardTranscations,
    countTransactions : state.reducer.countTransactions,
  };
};


export default connect(mapStateToProps, { transactionsAction })(Dashboard)